import { defineStore } from "pinia";
import { transformContinents } from "@utils/dataTransform";
import _ from "lodash";

export const useWorldStore = defineStore("world", {
    state: () => ({
        world: [],
        loaded: false,
    }),

    getters: {
        _transformed: (state) =>
            state.loaded ? transformContinents(state.world) : null,

        pinnedCities: (state) => state._transformed?.pinnedCities ?? [],
        continentOrder: (state) => state._transformed?.continentOrder ?? {},
        searchableCities: (state) => state._transformed?.searchableCities ?? [],
        continentLabels: (state) => state._transformed?.continentLabels ?? {},
        searchableCountries: (state) => {
            let allCountries = state.world
                ?.flatMap(({ countries }) => countries)
                .filter(Boolean);
            let countries = [
                ...new Set(allCountries.map((o) => JSON.stringify(o))),
            ].map((string) => JSON.parse(string));
            return _.orderBy(countries, "name");
        },
    },

    actions: {
        setup() {
            this.getWorld();
        },

        async load() {
            if (this.loaded) return;
            await this.getWorld();
        },

        getWorld() {
            return axios
                .get("/api/world")
                .then((world) => {
                    this.world = world.data;
                    this.loaded = true;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
});
